<template>
  <div
    :content="`Nível ${tier}`"
    v-tippy="{ arrow: true, theme: 'green', placement: 'bottom' }"
  >
    <i v-html="icon"></i>
    <span class="sr-only"> Nível {{ tier }} </span>
  </div>
</template>

<script>
export default {
  props: {
    tier: {
      type: String,
      required: true,
      validator: (val) => {
        return ["BASIC", "PRO", "MAX", "NO_TIER"].includes(val);
      },
    },
  },
  computed: {
    icon() {
      const tiers = {
        BASIC: this.$icons.basic,
        PRO: this.$icons.pro,
        MAX: this.$icons.max,
      };
      return tiers[this.tier];
    },
  },
};
</script>

<style></style>
